var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBarSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8380_20957)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 3.5,
    r: 2.5,
    fill: "#009A7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 9V1H3.22222V3.76923L4.61111 5.30769H6V9H1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83472 6.54896L8.19236 4.9066C8.54375 4.40104 8.75 3.78715 8.75 3.125C8.75 1.39896 7.35104 0 5.625 0C4.92153 0 4.27222 0.232639 3.74965 0.625H1.12604C0.504167 0.625 0 1.12917 0 1.75104V8.87396C0 9.49583 0.504167 10 1.12604 10H5.57049C6.19236 10 6.69653 9.49583 6.69653 8.87396V6.06146C6.95035 5.9684 7.18854 5.8441 7.40694 5.69236L9.0493 7.33472C9.26632 7.55174 9.61805 7.55174 9.83507 7.33472C10.0521 7.11771 10.0521 6.76597 9.83507 6.54896H9.83472ZM5.58542 8.66528C5.58542 8.78889 5.48542 8.88889 5.36181 8.88889H1.33472C1.21111 8.88889 1.11111 8.78889 1.11111 8.66528V1.95972C1.11111 1.83611 1.21111 1.73611 1.33472 1.73611H2.825C2.825 1.73611 2.825 1.73611 2.825 1.73576C2.61701 2.15417 2.49965 2.62604 2.49965 3.125C2.49965 4.8375 3.87743 6.22813 5.58472 6.24965V6.44028V8.66528H5.58542ZM5.625 5.13889C4.51458 5.13889 3.61111 4.23542 3.61111 3.125C3.61111 2.01458 4.51458 1.11111 5.625 1.11111C6.73542 1.11111 7.63889 2.01458 7.63889 3.125C7.63889 4.23542 6.73542 5.13889 5.625 5.13889Z",
    fill: "#231E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8380_20957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarSearchIcon);
export default __webpack_public_path__ + "static/media/SideBarSearchIcon.d8c851840ecfbc80b14ad634edcb5477.svg";
export { ForwardRef as ReactComponent };